import { provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
//import { ServiceWorkerModule } from '@angular/service-worker';

// import { SplashScreen } from '@capacitor/splash-screen';
// import { StatusBar } from '@capacitor/status-bar';
import { IonicModule } from '@ionic/angular';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
// component
import { AppComponent } from './app.component';
import { ErrorComponent } from './components/error/error.component';
import { LoadingComponent } from './components/loading/loading.component';
import { PushNotificationsAccessComponent } from './components/push-notifications-access/push-notifications-access.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { LayoutComponent } from './layout/layout.component';
import { SharedModule } from './modules/shared/shared.module';
import { MarkdownModule  } from 'ngx-markdown'




// export function appInit(appService: AppService) {
//   return () => appService.appInit();
// }



@NgModule({ declarations: [
        AppComponent,
        LayoutComponent,
        ErrorComponent,
        LoadingComponent,
        PushNotificationsAccessComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        SharedModule,
        // ServiceWorkerModule.register('/ngsw-worker.js', {
        //   enabled: true
        // }),
        MarkdownModule.forRoot(),
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireMessagingModule,
        AngularFireAuthModule,
        ReactiveFormsModule], providers: [
        provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({}))
    ] })
export class AppModule { }
